// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1rUUt","inner":"Form_inner__2DCzq","range":"Form_range__3sWsh","name":"Form_name__1Sbzh","actions":"Form_actions__PoSGI"};